const secrets = {
    // URLs
    // apiUrl: 'http://localhost:3000',
    // appUrl: 'http://localhost:4200',
    // openUrl: 'http://localhost:4300',
     apiUrl: 'https://api.synergatika.gr',
     appUrl: 'https://wallet.synergatika.gr',
     openUrl: 'https://open.synergatika.gr',
    staticUrl: 'https://wp.synergatika.gr/wp-json/wp/v2',

    // Map Key
    mapApiKey: 'AIzaSyC8tI34nghyWlMaQhGluC9f6jG7E8swyVQ',
}

export default secrets;